<template>
  <div class="loading-wrapper d-flex align-items-center">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
      <slot>{{message}}</slot>
    </div>
</template>
<script>
export default {
  props: {
    message: {
      default: 'Loading data...',
      type: String,
    },
  },
};
</script>

<style lang="scss">
.loading-wrapper {
  .lds-ripple {
    display: inline-block;
    height: 60px;
    position: relative;
    width: 60px;
  }
  .lds-ripple div {
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    border: 4px solid $dark;
    border-radius: 50%;
    opacity: 1;
    position: absolute;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      height: 0;
      left: 26px;
      opacity: 1;
      top: 26px;
      width: 0;
    }
    100% {
      height: 52px;
      left: 0px;
      opacity: 0;
      top: 0px;
      width: 52px;
    }
  }
}
</style>
